import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-middle-school-cte-courses',
  imports: [PillarPagesTemp],
  templateUrl: './middle-school-cte-courses.html',
  styleUrl: './middle-school-cte-courses.scss',
})
export class MiddleSchoolCteCourses {

}
